import React from 'react';
import { sb } from '../../../modules/state';
import { useAuth } from '../../../context/AuthContext';
import { ProtocolPage } from './ProtocolPage';

export function ProtocolIRF() {
  const { currentUser } = useAuth();
  const [isLocked, setIsLocked] = React.useState(false);

  const checkGate = async () => {
    if (!sb || !currentUser?.id) {
      setIsLocked(true);
      return false;
    }

    // Check if irf_candidate is set (admin only)
    const { data, error } = await sb.from('profiles').select('irf_candidate').eq('id', currentUser.id).single();

    if (error || !data || data.irf_candidate !== true) {
      setIsLocked(true);
      return false;
    }

    return true;
  };

  React.useEffect(() => {
    checkGate();
  }, [currentUser]);

  const handleApply = () => {
    window.location.href = 'mailto:francois@222fasting.com?subject=IRF%20Application';
  };

  const biochemistryList = (
    <ul className="list-disc list-inside space-y-1">
      <li>Maximum mitophagy — damaged mitochondria recycled at peak rate</li>
      <li>Brain shifts almost entirely to ketone metabolism</li>
      <li>Beta-hydroxybutyrate increases BDNF — neuroprotection</li>
      <li>Systemic anti-inflammatory effect — IL-6 and CRP drop dramatically</li>
      <li>Deep autophagy — cellular renewal at maximum</li>
    </ul>
  );

  // Francois's insulin data table
  const insulinDataTable = (
    <div className="overflow-x-auto">
      <table className="w-full text-sm text-on-surface-variant">
        <thead>
          <tr className="border-b border-outline">
            <th className="text-left py-2 font-semibold">Date</th>
            <th className="text-left py-2 font-semibold">Insulin</th>
            <th className="text-left py-2 font-semibold">Context</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-b border-outline">
            <td className="py-2">2022 pre-fast</td>
            <td className="py-2">33.0 mIU/L</td>
            <td className="py-2">Storage hormone fully dominant</td>
          </tr>
          <tr className="border-b border-outline">
            <td className="py-2">Day 120 of 222-day fast</td>
            <td className="py-2">~2.5 mIU/L</td>
            <td className="py-2">IRF completion criterion met</td>
          </tr>
          <tr className="border-b border-outline">
            <td className="py-2">2025 post-relapse</td>
            <td className="py-2">8.3 mIU/L</td>
            <td className="py-2">Metabolic reset maintained</td>
          </tr>
          <tr>
            <td className="py-2">February 2026 Day 28</td>
            <td className="py-2">19.5 mIU/L</td>
            <td className="py-2">Current campaign — active</td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  return (
    <ProtocolPage
      protocolName="IRF"
      tagline="The Biochemical Mission"
      tierBadge="Application"
      whatIs="The Insulin-Reset Fast. Not defined by time — defined by a number. Fast until fasting insulin drops below 6 mIU/L on two consecutive fortnightly tests. The only fasting protocol with a biochemical completion criterion."
      biochemistry={biochemistryList}
      whoItIsFor={
        <ul className="list-disc list-inside space-y-1">
          <li>Fasting insulin above 15 mIU/L — primary candidate</li>
          <li>Severely obese with failed standard protocols</li>
          <li>Metabolic syndrome diagnosed</li>
          <li>Not for Type 1 Diabetes, pregnancy, or active eating disorder history</li>
        </ul>
      }
      francoisSays="I did not invent this protocol in a lab. I survived it. My potassium hit 2.3 mmol/L and I did not die. I am not a hero — I had Slow-K. The IRF is not for everyone. It is for the ones who have tried everything else and need the biochemistry to change before anything else can."
      ctaText="Apply for IRF"
      isLocked={isLocked}
      lockedMessage="The IRF is by personal application only. Every candidate is reviewed by Francois personally."
      lockedCtaText="Apply for IRF"
      onCtaClick={handleApply}
    />
  );
}
